import React, { useContext } from 'react';

import { type Company, CompanyContext } from 'common/containers/CompanyContainer';
import { SyncIntegrationOptionValue } from 'common/subdomain/admin/AdminOnboarding/constants';
import {
  type SyncIntegrationOptionValueKey,
  syncIntegrations,
} from 'common/subdomain/admin/AdminOnboarding/data';
import OnboardingIntegrationCard from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingIntegrationCard';
import VStack from 'common/uiV3/VStack';

const OnboardingSyncIntegrations = () => {
  const company = useContext(CompanyContext);

  return (
    <VStack className="gap-4">
      {Object.entries(syncIntegrations).map(([integrationID, integration]) => {
        return (
          <OnboardingIntegrationCard
            key={integration.label}
            icon={integration.icon}
            title={integration.label}
            description={integration.description}
            href={integration.url}
            isInstalled={isSyncIntegrationInstalled(
              integrationID as SyncIntegrationOptionValueKey,
              company,
            )}
            tag={integration.tag}
            installButtonTitle={integration.installButtonTitle}
          />
        );
      })}
    </VStack>
  );
};

const isSyncIntegrationInstalled = (
  integrationID: SyncIntegrationOptionValueKey,
  company: Company,
) => {
  if (integrationID === SyncIntegrationOptionValue.Sdk) {
    return company?.stats.hasUsedIdentify || company?.stats.hasUsedSSO;
  } else {
    return company?.activeIntegrations[integrationID] ?? false;
  }
};

export const isSelectedSyncIntegrationsInstalled = (company: Company) => {
  return Object.keys(syncIntegrations).some((integrationID) =>
    isSyncIntegrationInstalled(integrationID as SyncIntegrationOptionValueKey, company),
  );
};

export default OnboardingSyncIntegrations;
